import React, {useEffect, useRef} from 'react'
import {Transformer} from 'react-konva'
import {TransformerLayerProps} from './TransformerLayer'

const attributesWhitelist = ['x', 'y', 'width', 'height', 'rotation']

export function RectTransformerLayer(props: TransformerLayerProps) {
  const rotationRef = useRef(props.shapeRef.current?.getAttr('rotation'))

  const handleChangeDrag = (e) => {
    const shape = props.shapeRef.current

    const attributes = shape.getAttrs()
    const newProps: Record<string, any> = {}
    for (const attributeName of attributesWhitelist) {
      let value = attributes[attributeName]

      if (typeof value === 'number') {
        value = Math.round(value)
      }
      newProps[attributeName] = value
    }

    props.onChange?.({
      type: props.element.type,
      elementId: props.element.elementId,
      name: props.element.name,
      shapeType: props.element.shapeType,
      props: newProps,
    })
  }

  const handleChangeTransform = (e) => {
    const shape = props.shapeRef.current

    const attributes = shape.getAttrs()

    // fix for bug in Konva - when rotation happens using transformer,
    // it can also change width and height on the element itself (if it was
    // changed previously), so we can't take rotation+width+height every time
    // and need to update rotation alone if it changes. rotationRef is used
    // to track current value to understand if it was changed
    if (rotationRef.current !== attributes.rotation) {
      rotationRef.current = attributes.rotation
      props.onChange?.({
        type: props.element.type,
        elementId: props.element.elementId,
        name: props.element.name,
        shapeType: props.element.shapeType,
        props: {
          ...props.element.props,
          rotation: attributes.rotation,
          x: attributes.x,
          y: attributes.y,
        },
      })
      return
    }

    const newProps: Record<string, any> = {}
    for (const attributeName of attributesWhitelist) {
      let value = attributes[attributeName]

      if (attributeName === 'width') {
        console.log(value)
        value = value * attributes.scaleX
      }
      if (attributeName === 'height') {
        value = value * attributes.scaleY
      }
      if (typeof value === 'number') {
        value = Math.round(value)
      }
      newProps[attributeName] = value

      shape.setAttr(attributeName, value)
    }

    shape.scaleX(1)
    shape.scaleY(1)

    props.onChange?.({
      type: props.element.type,
      elementId: props.element.elementId,
      name: props.element.name,
      shapeType: props.element.shapeType,
      props: newProps,
    })
  }

  // TODO: blinking after resize
  useEffect(() => {
    const shape = props.shapeRef.current
    shape.scaleX(1)
    shape.scaleY(1)
  }, [props.element])

  const cleanupTransform = (e) => {
    const shape = props.shapeRef.current
    const attributes = shape.getAttrs()
    attributes.scaleX = 1
    attributes.scaleY = 1
  }

  return (
    <Transformer
      flipEnabled={false}
      rotateEnabled={props.mode === 'edit'}
      ref={props.transformerRef}
      draggable={props.mode === 'edit'}
      borderEnabled={true}
      resizeEnabled={props.mode === 'edit'}
      onDragMove={handleChangeDrag}
      onTransform={handleChangeTransform}
    />
  )
}
